import React, {useEffect, useMemo, useState} from 'react';
import {Modal, Row, Col} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import * as Yup from 'yup';
import {GreenButton, WhiteButton} from '@styled';
import {Input, Form, MainLoader, DropdownField} from '@components';
import {useDispatch, useSelector} from 'react-redux';
import {get} from 'lodash';
import {sagaActions} from './redux/saga';
import {resetFormSubmitSuccess, resetFormError} from './redux/index';

const AddEditInputField = ({show, sourceId, editRow, toggleModal}) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const [editMode, setEditMode] = useState('add');
  const staticConfigFields = useSelector(
    (state) => state.calcEngine.sourceInputFields.staticConfigFields
  );

  // const inputTableFields = useSelector(
  //   (state) => state.calcEngine.sourceInputFields.data
  // );

  const isLoading = useSelector((state) => state.calcEngine.formLoading);
  const formError = useSelector((state) => state.calcEngine.formError);
  const formSubmitSuccess = useSelector(
    (state) => state.calcEngine.formSubmitSuccess
  );

  const [defaultValues, setDefaultValues] = useState({
    fieldLevel: '',
    fieldType: '',
    calculationField: '',
  });

  useEffect(() => {
    if (formSubmitSuccess) {
      dispatch(resetFormSubmitSuccess(false));
      toggleModal(false);
    }
  }, [formSubmitSuccess]);

  useEffect(() => {
    dispatch(resetFormError(''));
  }, [show]);

  const {fieldLevels, fieldTypes, calcFields} = useMemo(() => {
    const lFieldLevels = get(staticConfigFields, 'fieldLevel', []).map(
      (level) => ({label: level, value: level})
    );
    const lFieldTypes = get(staticConfigFields, 'fieldType', []).map(
      (fType) => ({label: fType, value: fType})
    );

    const lCalcFields = get(staticConfigFields, 'calculationField', []).map(
      (cField) => ({label: cField, value: cField})
    );

    return {
      fieldLevels: lFieldLevels,
      fieldTypes: lFieldTypes,
      calcFields: lCalcFields,
    };
  }, [staticConfigFields]);

  const handleSubmit = (values) => {
    // setErrors
    // validate field Level already added
    // const foundLevelField = inputTableFields.find((field) => {
    //   const sameFieldId = editRow ? field.id !== editRow.id : true;
    //   return !sameFieldId && field.fieldLevel === values.fieldLevel.value;
    // });
    // if (foundLevelField) {
    //   setErrors({
    //     fieldLevel: t(
    //       `owner.calcEngine.inputTableConfig.required.existsFieldLevel`
    //     ),
    //   });
    //   return;
    // }

    dispatch({
      type:
        editMode === 'update'
          ? sagaActions.UPDATE_INPUT_TABLE_FIELD
          : sagaActions.CREATE_INPUT_TABLE_FIELD,
      payload: {
        sourceId,
        fieldId: editRow ? editRow.id : 0,
        values: {
          ...values,
          fieldLevel: values.fieldLevel.value,
          fieldType: values.fieldType.value,
          calculationField: values.calculationField.value,
        },
      },
    });
  };

  useEffect(() => {
    setEditMode(editRow ? 'update' : 'add');
    let fieldLevel = get(editRow, 'fieldLevel', '');
    let fieldType = get(editRow, 'fieldType', '');
    let calculationField = get(editRow, 'calculationField', '');

    if (fieldLevel) {
      fieldLevel = fieldLevels.find((item) => item.value === fieldLevel) || '';
    }
    if (fieldType) {
      fieldType = fieldTypes.find((item) => item.value === fieldType) || '';
    }

    if (calculationField) {
      calculationField =
        calcFields.find((item) => item.value === calculationField) || '';
    }

    setDefaultValues({fieldLevel, fieldType, calculationField});
  }, [editRow]);

  return (
    <Modal
      show={show}
      onHide={() => toggleModal(false)}
      centered
      // scrollable
      keyboard={false}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <h6>{t(`owner.calcEngine.inputTableConfig.${editMode}`)}</h6>
      </Modal.Header>
      <Modal.Body>
        {isLoading && (
          <MainLoader
            minHeight="100vh"
            spinnerColor="#479541"
            background="rgba(0,0,0,0.2)"
          />
        )}
        <Form
          initialValues={{
            fieldName: editRow ? editRow.fieldName : '',
            ...defaultValues,
          }}
          validationSchema={Yup.object({
            fieldName: Yup.string().required(
              t('owner.calcEngine.inputTableConfig.required.fieldName')
            ),
            fieldLevel: Yup.object().required(
              t('owner.calcEngine.inputTableConfig.required.fieldLevel')
            ),
            fieldType: Yup.object().required(
              t('owner.calcEngine.inputTableConfig.required.fieldType')
            ),
            calculationField: Yup.object().required(
              t('owner.calcEngine.inputTableConfig.required.calculationField')
            ),
          })}
          onSubmit={(values, {setErrors}) => {
            handleSubmit(values, setErrors);
          }}
          enableReinitialize={editMode === 'update' ? true : false}
        >
          {formError && <div className="alert alert-danger">{formError}</div>}
          <Row>
            <Col>
              <Input
                type="text"
                name="fieldName"
                id="fieldName"
                label={t('owner.calcEngine.inputTableConfig.fieldName')}
                placeholder=""
                required
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <DropdownField
                id="fieldLevel"
                name="fieldLevel"
                label={t('owner.calcEngine.inputTableConfig.fieldLevel')}
                options={fieldLevels}
                placeholder=""
                required
                menuPortalTarget="parent"
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <DropdownField
                id="fieldType"
                name="fieldType"
                label={t('owner.calcEngine.inputTableConfig.fieldType')}
                options={fieldTypes}
                placeholder=""
                required
                menuPortalTarget="parent"
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <DropdownField
                id="calculationField"
                name="calculationField"
                label={t('owner.calcEngine.inputTableConfig.calculationField')}
                options={calcFields}
                placeholder=""
                required
                menuPortalTarget="parent"
              />
            </Col>
          </Row>
          <div
            style={{
              visibility: 'hidden',
              width: 0,
              lineHeight: 0,
              padding: 0,
              margin: 0,
              fontSize: 0,
            }}
          >
            <GreenButton id="mEditInputFSubmitBtn" type="submit">
              {t(`owner.calcEngine.inputTableConfig.${editMode}BtnLabel`)}
            </GreenButton>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <GreenButton
          type="button"
          className="mr-1"
          onClick={() => {
            document.getElementById('mEditInputFSubmitBtn').click();
          }}
        >
          {t(`owner.calcEngine.inputTableConfig.${editMode}BtnLabel`)}
        </GreenButton>
        <WhiteButton
          type="button"
          className="ml-1"
          onClick={() => toggleModal(false)}
        >
          {t('owner.calcEngine.inputTableConfig.cancelBtnLabel')}
        </WhiteButton>
      </Modal.Footer>
    </Modal>
  );
};

export default AddEditInputField;
